import React, {Component} from "react"

import Screen from '../ui/Screen'

import ExpandState from "./../ui/ExpandState"

import ErrorMessageDialog from "../ui/ErrorMessageDialog.js"

import ControlPanel from "./PurchasesTemplatesScreen/ControlPanel"

import api from "../api"

import ItemsList from "./PurchasesTemplatesScreen/ItemsList.js"

import CreateFolderDialog from "./PurchasesTemplatesScreen/CreateFolderDialog"
import CreateTemplateDialog from "./PurchasesTemplatesScreen/CreateTemplateDialog"
import EditTemplateScreen from "./PurchasesTemplatesScreen/EditTemplateScreen.js"
import DeleteTemplateDialog from "./PurchasesTemplatesScreen/DeleteTemplateDialog.js"
import EditTemplateDialog from "./PurchasesTemplatesScreen/EditTemplateDialog.js"
import SelectFolderDialog  from "./PurchasesTemplatesScreen/SelectFolderDialog.js"

class PurchasesTemplatesScreen extends Component {

    constructor(props) {
        super(props)

        this.expandState = new ExpandState()

        this.state = {
            dialog: undefined,
            screen: undefined,
            selected: undefined,
            templates: [],
            folder_id: 0,
            parent_folder_id: 1,
        }

        this.handle_onCreateFolderClick = this.handle_onCreateFolderClick.bind(this)
        this.handle_onCreateTemplateClick = this.handle_onCreateTemplateClick.bind(this)
        this.handle_onEditTemplateAttachmentsClick = this.handle_onEditTemplateAttachmentsClick.bind(this)
        this.handle_onMoveToFolderClick = this.handle_onMoveToFolderClick.bind(this)
        this.handle_onEditClick = this.handle_onEditClick.bind(this)
        this.handle_onDeleteClick = this.handle_onDeleteClick.bind(this)
        this.handle_error = this.handle_error.bind(this)

        this.update = this.update.bind(this)
    }

    componentDidMount = () => this.update().catch(this.handle_error)

    /**
     * Диалог сообщения о ошибке.
     * 
     * @param {string|Error} error - ошибка.
     */

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => {
					this.update()
                        .then(() => this.setState({dialog: undefined}))
                        .catch(this.handle_error)
				}}
			/>
		})
	}

    /**
     * Обновление (списка шаблонов).
     * 
     * @return Promise
     */

    async update() {
        const templates = await api.purchases_templates.list(this.state.folder_id)
        this.setState({templates: templates})
    }

    /**
     * Событие для нажатие на кнопку создать в диалоге создания папки.
     * 
     * @param {} selected - выбранный элемент 
     */

    handle_onCreateFolderClick(selected) {
        this.setState({
            dialog: <CreateFolderDialog
                onCreateClick = {name => {
                    api.purchases_templates.create(name, 0, this.state.folder_id)
                        .then(response => api.purchases_templates.get(response["id"]))
                        .then(template => this.setState({selected: template}))
                        .then(this.update)
                        .then(() => this.setState({dialog: undefined}))
                        .catch(this.handle_error)
                }}
                onCancelClick = {() => this.setState({dialog: undefined})}
            />
        })
    }

    /**
     * Обработчик нажатия на кнопку создания шаблона.
     * 
     * @param {*} selected - выбранный шаблон. 
     * Нужен для определения folder_id, иначе шаблон будет создан в корневом каталоге.
     */

    handle_onCreateTemplateClick(selected) {
        this.setState({
            dialog: <CreateTemplateDialog 
                selected = {this.state.selected}
                folder_id = {this.state.folder_id}
                onCreateClick = {template => {
                    this.setState({
                        dialog: undefined,
                        screen: <EditTemplateScreen 
                            template = {template}
                            onSaveClick = {template => {
                                api.purchases_templates.create(template.name, template.type, template.folder_id)
                                    .then(async response => {
                                        for (let attachment of template.attachments) {
                                            await api.purchases_templates.attachments.create(response["id"], attachment.item_id, attachment.quantity, attachment.shop_id)
                                        }
                                        return response["id"]
                                    })
                                    .then(this.update)
                                    .then(() => {this.setState({dialog: undefined, screen: undefined})})
                                    .catch(error => this.setState({screen: undefined}, this.handle_error(error)))
                            }}
                            onCancelClick = {() => this.setState({screen: undefined})}
                        />
                    })
                }}
                onCancelClick = {() => this.setState({dialog: undefined})}
            />
        })
    }

    /**
     * Обработка события нажатия на кнопку редактирования вложения.
     * 
     * @param {*} template - выбранный шаблон закупки.
     */

    handle_onEditTemplateAttachmentsClick(template) {

        /**
         * Обновление вложений.
         * 
         * @param {*} template_edited - исправленный шаблон
         * @param {*} template - оригинальный шаблон (для поиска изменений).
         */

        const update_attachments = async (template_edited, template) => {
            let template_id = template.id
            // Если новое вложение (id помечен как new{n}) то создаем его
            for (let attachment of template_edited.attachments) {
                if (isNaN(Number(attachment.id))) {
                    await api.purchases_templates.attachments.create(template_id, attachment.item_id, attachment.quantity, attachment.shop_id)
                } 
            }
            // Если вложение пропало, значит его надо удалить, иначе обновить.
            for (let attachment of template.attachments) {
                const a = template_edited.attachments.find(a => a.id === attachment.id)
                if (a) {
                    await api.purchases_templates.attachments.update(a.id, a.quantity, a.shop_id)
                } else {
                    await api.purchases_templates.attachments.delete(attachment.id)
                }
            }
        }    

        this.setState({
            screen: <EditTemplateScreen 
                template = {template}
                onSaveClick = {
                    template_edited => update_attachments(template_edited, template)
                        .then(this.update)
                        .then(() => this.setState({
                            selected: this.state.templates.find(t => t.id === template_edited.id),
                            screen: undefined,
                        }))
                        .catch(error => this.setState({screen: undefined}, () => this.handle_error(error)))
                }
                onCancelClick = {() => this.setState({screen: undefined})}
            />
        })
    }

    /**
     * Обработка нажатия на кнопку переноса шаблона или папки в папку.
     * 
     * @param {} selected 
     */

    handle_onMoveToFolderClick(selected) {
        this.setState({dialog: <SelectFolderDialog 
            exclude = {selected}
            folder_id = {selected.folder_id}
            onSelectClick = {folder_id => {
                api.purchases_templates.move_to_folder(selected.id, folder_id)
                    .then(this.setState({folder_id: folder_id}))
                    .then(this.update)
                    .then(this.setState({dialog: undefined}))
                    .catch(this.handle_error)
            }}
            onCancelClick = {() => {this.setState({dialog: undefined})}}
        />})
    }

    /**
     * Обработка события нажатия на кнопку редактировать.
     * 
     * @param {*} selected - выбранный элемент.
     * @return {} - изменённый объект.
     */

    handle_onEditClick(selected) {
        this.setState({
            dialog: <EditTemplateDialog 
                selected = {this.state.selected}
                onSaveClick = {template => {
                    api.purchases_templates.update(template.id, template.name)
                        .then(this.update)
                        .then(this.setState({dialog: undefined}))
                        .catch(this.handle_error)
                }}
                onCancelClick = {() => this.setState({dialog: undefined})}
            />
        })
    }

    /**
     * Обработчик события нажатия на кнопку удалить.
     * 
     * @param {*} selected - выбранный элемент списка шаблонов закупок, кандидат на удаление.
     */

    handle_onDeleteClick(selected) {
        this.setState({dialog: <DeleteTemplateDialog 
            selected = {selected}
            onDeleteClick = {template => {
                api.purchases_templates.delete(template.id)
                    .then(this.update)
                    .then(this.setState({selected: undefined, dialog: undefined}))
                    .catch(this.handle_error)
            }}
            onCancelClick = {() => {this.setState({dialog: undefined})}}
        />})
    }

    render() {

		if (this.state.screen) {
			return this.state.screen
		}

        return <Screen
            onClick = {e => {
                if (!this.state.dialog) {
                    e.stopPropagation()
                    this.setState({selected: undefined})
                }
            }}
        >
            
            {this.state.dialog}
            
            <ControlPanel
                selected = {this.state.selected}
                onCreateFolderClick = {this.handle_onCreateFolderClick}
                onCreateTemplateClick = {this.handle_onCreateTemplateClick}
                onEditTemplateAttachmentsClick = {this.handle_onEditTemplateAttachmentsClick}
                onMoveToFolderClick = {this.handle_onMoveToFolderClick}
                onEditClick = {this.handle_onEditClick}
                onDeleteClick = {this.handle_onDeleteClick}
            />

            <ItemsList
                items = {this.state.templates}
                selected = {this.state.selected}
                folder_id = {this.state.folder_id}
                onItemClick = {template => this.setState({selected: template})}
                onItemDoubleClick = {template => {
                    this.setState({selected: template}, () => {
                        if (template.type === 0) {
                            this.setState({selected: undefined, folder_id: template.id}, () => this.update().catch(this.handle_error))
                        } else {
                            this.handle_onEditTemplateAttachmentsClick(template)
                        }
                    })
                }}
                onBackClick = {folder_id => {
                    api.purchases_templates.get(folder_id)
                        .then(template => {this.setState({folder_id: template.folder_id})})
                        .then(this.update)
                        .catch(this.handle_error)
                }}
            />

        </Screen>
    }

}

export default PurchasesTemplatesScreen